import i18n from "@/i18n.js";

export default [
  { id: "product_approver", name: i18n.t("integrations.user.attribute.product_approver") },
  { id: "order_approver", name: i18n.t("integrations.user.attribute.order_approver") },
  { id: "newsletter_subscribed", name: i18n.t("integrations.user.attribute.newsletter_subscribed") },
  { id: "newsletter_unsubscribed", name: i18n.t("integrations.user.attribute.newsletter_unsubscribed") }
];
